import React, {useState} from 'react';
import {LoginLayout} from '../../Layouts/LoginLayout';
import {LoginForm} from '../../Components/Form/LoginForm';
import {LoginPayloadRequest, loginUser, logout} from '../../Context/AuthProvider/AuthProviderActions';
import {addAlert} from '../../Context/AlertProvider/AlertProviderActions';
import {useAuthDispatch, useAuthState} from '../../Context/AuthProvider/AuthProvider';
import {useAlertDispatcherState} from '../../Context/AlertProvider/AlertProvider';
import {useParameterizedQuery} from 'react-fetching-library';
import {validateMigrationToken} from '../../Actions/Company/CompanyActions';
import {useNavigate} from 'react-router-dom';
import {EmptyState} from '../../Components/EmptyState';

export const LoginMigration:React.FunctionComponent = (_props) => {
    const [validCompany, setValidCompany] = useState<string>('');
    const [useAut0, setUseAut0] = useState<boolean>(true);
    const [hasLogin, setHasLogin] = useState<boolean>(false);

    const dispatch = useAuthDispatch();
    const alertDispatch = useAlertDispatcherState();

    const {token} = useAuthState();

    const validateTokenAction = useParameterizedQuery(validateMigrationToken);

    const navigate = useNavigate();

    const handleBasicLogin =  React.useCallback( async (payload:LoginPayloadRequest)=>{
        if (!useAut0){
            try {
                loginUser(payload, dispatch).then( responseLogin => {
                    if (!responseLogin || !responseLogin.response || !responseLogin.response.user || responseLogin.response.user.id <= 0) return;
                    setHasLogin(false);
                    addAlert('Autentificación exitosa', '¡Felicidades, se ha verificado tu identidad exitosamente!' ,'success', alertDispatch );
                } );
            } catch (error) {
                console.log(error);
            }
        }else{
            console.log( useAut0 );
        }

    }, [alertDispatch, dispatch, useAut0] );

    React.useEffect( () => {
        if(!hasLogin){
            setHasLogin(true);
            if( token !== undefined && token !== '') {
                validateTokenAction.query({}).then( (res) => {
                    if (res.payload){
                        const response = res.payload;
                        if ( response.error['has-error'] ){
                            logout(dispatch).then();
                            setValidCompany('');
                            setHasLogin(false);
                        }else{
                            navigate('/migration/table');
                            addAlert('Información', `${ response.response }` ,'success', alertDispatch );
                        }
                    }
                } );
            }else{
                setValidCompany('');
            }
        }

    }, [alertDispatch, dispatch, hasLogin, navigate, token, validateTokenAction] );


    return (
        <LoginLayout loginTitle="Inicio de sesión requerido"
                        loginSubtitle="Ingresa tus credeciales para validar tu identidad y poder migrar los usuarios de la empresa."
        >
            {
                (validateTokenAction.loading ) ?
                    <EmptyState loading/> :
                    <LoginForm handleLogin={handleBasicLogin}
                               validCompany={validCompany}
                               setValidCompany={setValidCompany}
                               setUseAut0={ setUseAut0 }
                               loginOnlyDiazar
                    />
            }

        </LoginLayout>
    );
};
